function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".temperaturea{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-141.3 -2)"
}, /*#__PURE__*/React.createElement("path", {
  className: "temperaturea",
  d: "M196.53,202.112V190.5h-1.362v11.621a5.4,5.4,0,1,0,1.362-.008Zm-.681,9.486a4.087,4.087,0,1,1,4.087-4.087A4.094,4.094,0,0,1,195.849,211.6Z",
  transform: "translate(-45.022 -172.843)"
}), /*#__PURE__*/React.createElement("path", {
  className: "temperaturea",
  d: "M154.233,25.773V5.406a3.406,3.406,0,1,0-6.811,0V25.773a9.527,9.527,0,1,0,6.811,0Zm-3.406,17.061a8.175,8.175,0,0,1-8.165-8.165c0-6.2,6.122-7.924,6.122-7.924V5.406a2.043,2.043,0,1,1,4.087,0V26.753s6.122,1.645,6.122,7.924A8.173,8.173,0,0,1,150.827,42.834Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "temperaturea",
  width: 3.406,
  height: 1.362,
  transform: "translate(155.595 21.736)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "temperaturea",
  width: 2.043,
  height: 1.362,
  transform: "translate(155.595 17.657)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "temperaturea",
  width: 3.406,
  height: 1.362,
  transform: "translate(155.595 13.571)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "temperaturea",
  width: 2.043,
  height: 1.362,
  transform: "translate(155.595 9.484)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "temperaturea",
  width: 3.406,
  height: 1.362,
  transform: "translate(155.595 5.406)"
}));

var SvgTemperature = function SvgTemperature(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.055,
    height: 32.196,
    viewBox: "0 0 19.055 42.196",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemperature, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/temperature.8b92657a.svg";
export { ForwardRef as ReactComponent };